export const ASPECT_RATIO = 1375 / 940;
export const LIGHT_GREEN = "#43BA85";
export const DARK_GREEN = "#004B3D";
export const PALE_TAN = "#E3DCCF";
